window.Validation = (function($) {
    const self = {
        constants: {
            constraintList: [
                'valueMissing',
                'typeMismatch',
                'tooShort',
                'tooLong',
                'patternMismatch',
                'rangeUnderflow',
                'rangeOverflow',
                'stepMismatch',
                'customError'
            ],
            customConstraintList: {
                tooFewChecks: 'tooFewChecks'
            },
            customErrorConstraint: 'customError',
            defaultErrorMessage: 'Invalid input'
        },
        selectors: {
            formsToValidate: 'form[novalidate]',
            inputsToValidate: 'form[novalidate] .vds-form__group .vds-form__input',
            radiosToValidate: 'form[novalidate] .vds-form__group .vds-form__radio'
        },
        classes: {
            hidden: 'vds-item-hidden',
            invalidInput: 'vds-form__input--invalid'
        },
        attributes: {
            violatedConstraints: 'data-violated-constraints',
            messagePrefix: 'data-message-',
            customErrorMessage: 'data-message-customerror'
        },
        fieldGranularity: {
            standalone: 'standalone',
            fieldset: 'fieldset',
            subfield: 'subfield',
        },
        func: {
            init: function() {
                $(self.selectors.formsToValidate).on('submit', function(event) {
                    self.func.validateForm(event.target);
                    let hasCustomViolatedConstraints= self.func.hasCustomViolatedConstraints(event.target);
                    if (!event.target.checkValidity() || hasCustomViolatedConstraints) {
                        event.preventDefault();
                        event.stopImmediatePropagation();
                    }
                });
                $(self.selectors.inputsToValidate).on('change', function(event) {
                    self.func.clearCustomErrorMessage(event.target);
                    self.func.updateErrorMessage(event.target);
                });
                $(self.selectors.radiosToValidate).on('change', function(event) {
                    self.func.clearCustomErrorMessage(event.target);
                    self.func.updateErrorMessage(event.target);
                });
            },
            fieldGranularity: field => {
                if ($(field).is('.vds-form__fieldset')) {
                    return self.fieldGranularity.fieldset;
                }
                if ($(field).is('.vds-form__fieldset .vds-form__input')) {
                    return self.fieldGranularity.subfield;
                }
                if ($(field).is('.vds-form__fieldset .vds-form__radio')) {
                    return self.fieldGranularity.subfield;
                }
                if ($(field).is('.vds-form__input')) {
                    return self.fieldGranularity.standalone;
                }
                return null;
            },
            getValidationMessageElement: field => {
                return $(field).closest('.vds-form__group').find('.vds-form__validation-message');
            },
            getValidationTextElement: field => {
                return $(field).closest('.vds-form__group').find('.vds-form__validation-text');
            },
            hasCustomViolatedConstraints: form => {
                let validationTextJqo = $(form).find('.vds-form__validation-text');
                for (let i = 0; i < validationTextJqo.length; i++) {
                    let validationElement = validationTextJqo.get(i);
                    let violatedConstraintsAttr = $(validationElement).attr('data-violated-constraints');
                    let violatedConstraints = [];
                    if (violatedConstraintsAttr) {
                        violatedConstraints = JSON.parse(violatedConstraintsAttr);
                    }
                    if (violatedConstraints.length > 0) {
                        return true;
                    }
                }
                return false;
            },
            clearCustomErrorMessage: field => {
                if (self.func.fieldGranularity(field) === self.fieldGranularity.standalone) {
                    field.setCustomValidity('');
                }

                if (self.func.fieldGranularity(field) === self.fieldGranularity.fieldset) {
                    field.setCustomValidity('');
                    let subfieldsJqo = $(field).find('.vds-form__input');
                    for (let i = 0; i < subfieldsJqo.length; i++) {
                        let subfield = subfieldsJqo.get(i);
                        subfield.setCustomValidity('');
                    }
                }

                if (self.func.fieldGranularity(field) === self.fieldGranularity.subfield) {
                    let fieldsetJqo = $(field).closest('.vds-form__fieldset');
                    self.func.clearCustomErrorMessage(fieldsetJqo.get(0));
                }
            },
            updateErrorMessage: (field, constraints) => {
                if (self.func.fieldGranularity(field) === self.fieldGranularity.subfield) {
                    let fieldsetJqo = $(field).closest('.vds-form__fieldset')
                    self.func.updateErrorMessage(fieldsetJqo.get(0));
                    return;
                }

                let isValid = true;
                let violatedConstraints = [];
                let message = '';
                let fields;

                if (self.func.fieldGranularity(field) === self.fieldGranularity.standalone) {
                    isValid = field.checkValidity();
                    violatedConstraints = constraints || self.func.getViolatedConstraints(field.validity);
                    message = self.func.getMessageFromViolatedConstraints(field, violatedConstraints);
                    fields = $(field);
                }

                if (self.func.fieldGranularity(field) === self.fieldGranularity.fieldset) {
                    let validity = self.func.getFieldsetValidity(field, constraints);
                    isValid = validity.isValid;
                    violatedConstraints = validity.violatedConstraints;
                    message = self.func.getMessageFromViolatedConstraints(field, violatedConstraints) || validity.message;
                    fields = $(field).find('.vds-form__input');
                }

                let messageEl = self.func.getValidationMessageElement(field);
                let textEl = self.func.getValidationTextElement(field);

                textEl.html(message);
                textEl.attr(self.attributes.violatedConstraints, JSON.stringify(violatedConstraints));

                if (isValid) {
                    $(fields).removeClass(self.classes.invalidInput);
                    $(field).find('.vds-form__radios').removeClass('vds-form__radios--error');
                    messageEl.addClass(self.classes.hidden);
                } else {
                    $(fields).addClass(self.classes.invalidInput);
                    $(field).find('.vds-form__radios').addClass('vds-form__radios--error');
                    messageEl.removeClass(self.classes.hidden);
                }
            },
            getFieldsetValidity: (fieldset, constraints) => {
                let violations = [];
                let messages = [];

                if (constraints) {
                    violations.push(...constraints);
                }

                if ($(fieldset).attr('data-min-checked')) {
                    let minChecked = +($(fieldset).attr('data-min-checked'));
                    let checkedSubfields = $(fieldset).find('.vds-form__radio:checked');
                    if (checkedSubfields.length < minChecked) {
                        violations.push(self.constants.customConstraintList.tooFewChecks);
                        messages.push(self.func.getMessageFromViolatedConstraints(fieldset, violations));
                    }
                }

                let subfields = $(fieldset).find('.vds-form__input');
                for (let i = 0; i < subfields.length; i++) {
                    let subfield = subfields.get(i);
                    if (!subfield.checkValidity())
                    {
                        let violatedConstraints = self.func.getViolatedConstraints(subfield.validity);
                        violations.push(...violatedConstraints);
                        messages.push(self.func.getMessageFromViolatedConstraints(subfield, violations));
                    }
                }

                return {
                    isValid: violations.length === 0,
                    violatedConstraints: violations,
                    message: (messages.length > 0) ? messages[0] : ''
                }
            },
            getMessageFromViolatedConstraints(field, violatedConstraints) {
                if (violatedConstraints.length === 0) {
                    return '';
                }
                let messageEl = self.func.getValidationMessageElement(field);
                for (let i = 0; i < violatedConstraints.length; i++) {
                    let constraint = violatedConstraints[i];
                    let message = messageEl.attr(self.attributes.messagePrefix + constraint);
                    if (message) {
                        return message;
                    }
                }
                return field.validationMessage;
            },
            getViolatedConstraints: validationState => {
                let violatedConstraints = [];

                if (validationState.valid) {
                    return violatedConstraints;
                }

                for (let i = 0; i < self.constants.constraintList.length; i++) {
                    let constraint = self.constants.constraintList[i];
                    if (validationState[constraint]) {
                        violatedConstraints.push(constraint.toLowerCase());
                    }
                }

                return violatedConstraints;
            },
            validateForm: (form) => {
                self.func.validateFields($(form).find('.vds-form__input'));
                self.func.validateFields($(form).find('.vds-form__radio'));
                self.func.validateFields($(form).find('.vds-form__fieldset'));
            },
            validateFields: (fieldsJqo) => {
                for (let i = 0; i < fieldsJqo.length; i++) {
                    self.func.updateErrorMessage(fieldsJqo.get(i));
                }
            },
            setCustomErrors: (errors) => {
                for (let fieldSelector in errors) {
                    let field = $(fieldSelector).get(0);
                    let constraint = errors[fieldSelector];
                    if (field && constraint) {
                        self.func.setCustomError(field, constraint);
                    }
                }
            },
            setCustomError: (field, constraint) => {
                let messageEl = self.func.getValidationMessageElement(field);

                let constraintMessage = messageEl.attr(self.attributes.messagePrefix + constraint);
                let customErrorMessage = messageEl.attr(self.attributes.customErrorMessage);
                let defaultErrorMessage = self.constants.defaultErrorMessage;

                let violatedConstraints = [constraint];

                if (!violatedConstraints.includes(self.constants.customErrorConstraint)) {
                    violatedConstraints.push(self.constants.customErrorConstraint);
                }

                let message = constraintMessage || customErrorMessage || defaultErrorMessage;
                if (self.func.fieldGranularity(field) === self.fieldGranularity.fieldset) {
                    let subfields = $(field).find('.vds-form__input');
                    for (let i = 0; i < subfields.length; i++) {
                        let subfield = subfields.get(i);
                        subfield.setCustomValidity(message);
                    }
                    subfields.addClass(self.classes.invalidInput);
                    let textEl = self.func.getValidationTextElement(field);
                    textEl.attr(self.attributes.violatedConstraints, JSON.stringify(violatedConstraints));
                    textEl.html(message);
                    messageEl.removeClass(self.classes.hidden);
                } else {
                    field.setCustomValidity(message);
                    self.func.updateErrorMessage(field, violatedConstraints);
                }
            },
        }
    };

    return {
        init: self.func.init,
        setCustomErrors: self.func.setCustomErrors
    };
})(window.jQuery);

$(function() {
    window.Validation.init();
});
